/* eslint-disable */
// @ts-nocheck

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import query from '@/api/APIServicesV2'

export const GET_ALL_CONTAINERS_QUERY_KEY = 'containers'
export const GET_CONTAINER_QUERY_KEY = (containerId: number) => [
  'container',
  containerId,
]

export function useServerLogisticContainer() {
  const queryClient = useQueryClient()

  const getContainers = () => {
    return useQuery({
      queryKey: ['containers'],
      queryFn: async () => {
        const response = await query.get('/containers')
        return response.data
      },
    })
  }
  const getContainer = (containerId: number) => {
    return useQuery({
      queryKey: ['container', containerId],
      queryFn: async () => {
        const response = await query.get(`/containers/${containerId}`)
        return response.data
      },
      enabled: !!containerId,
    })
  }

  const createContainer = (data: any) => {
    return useMutation({
      mutationFn: async () => {
        const response = await query.post('/containers', data)
        return response.data
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [GET_ALL_CONTAINERS_QUERY_KEY],
        })
      },
    })
  }

  const updateContainer = (containerId: number, data: any) => {
    return useMutation({
      mutationFn: async () => {
        const response = await query.put(`/containers/${containerId}`, data)
        return response.data
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [
            GET_CONTAINER_QUERY_KEY(containerId),
            GET_ALL_CONTAINERS_QUERY_KEY,
          ],
        })
      },
    })
  }
  const deleteContainer = (containerId: number) => {
    return useMutation({
      mutationFn: async () => {
        const response = await query.deleteAPI(`/containers/${containerId}`)
        return response.data
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [GET_ALL_CONTAINERS_QUERY_KEY],
        })
      },
    })
  }
  return {
    getContainers,
    getContainer,
    createContainer,
    updateContainer,
    deleteContainer,
  }
}
